module.exports = __webpack_public_path__ + "img/cantdelimar-logo-letras.9e9f5c59.png";